<template>
  <div>
    <b-button
      :id="isSinglePage ? 'assignGroups' : `groupsPopoverButton${componentId}`"
    >
      Assign Groups
    </b-button>
    <b-popover
      id="groups-popover"
      ref="popover"
      :custom-class="!isSinglePage ? 'mh-200' : ''"
      :target="isSinglePage ? 'assignGroups' : `groupsPopoverButton${componentId}`"
      placement="top"
      triggers="click blur"
      @hidden="onModalHidden"
      @shown="onModalShown"
    >
      <template #title>
        Search Groups
      </template>
      <div class="p-2">
        <input
          ref="groupsSearchInput"
          v-model="keyword"
          class="form-control"
          placeholder="Type to search Groups"
        >
      </div>
      <b-list-group-item
        v-for="group in filteredGroups"
        button
        class="d-flex align-items-center"
        @click="groupSelect(group)"
      >
        <b-avatar
          variant="primary"
          :text="getAvatarText(group)"
          class="mr-3"
        />
        <span class="mr-auto">{{ group.DisplayName }}</span>
        <font-awesome-icon
          v-if="selectedGroups.indexOf(group.Id) > -1"
          class="text-success"
          :icon="['fas', 'check']"
        />
      </b-list-group-item>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: 'GroupListPopover',
  props: {
    groups: {
      type: Array,
      required: true,
    },
    selectedGroups: {
      type: Array,
      default: () => [],
    },
    isSinglePage: {
      type: Boolean,
      default: true,
    },
    componentId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      keyword: '',
    };
  },
  computed: {
    filteredGroups() {
      return this.keyword ? this.groups.filter(group => group.DisplayName.toLowerCase().includes(this.keyword.toLowerCase())) : this.groups;
    },
  },
  methods: {
    getAvatarText(group) {
      return group.DisplayName[0].toUpperCase();
    },
    groupSelect(group) {
      this.$refs.popover.$emit('close');
      if (this.selectedGroups.indexOf(group.Id) > -1) {
        this.$emit('groupRemove', group);
      } else {
        this.$emit('groupSelect', group);
      }
    },
    onModalShown() {
      this.$refs.groupsSearchInput.focus();
    },
    onModalHidden() {
      this.keyword = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.mh-200 {
  max-height: 200px !important;
}
</style>